import '../style/yearpage.css';
import { useNavigate } from 'react-router-dom';
import UgandaImage from '../components/uganda.png';
import KyrgyzstanImage from '../components/Kyrgyzstan.png';

function Year2024() {
    const navigate = useNavigate(); // Initialize the navigate function
  
    // Function to handle container clicks
    const handleContainerClick = (path) => {
      navigate(path); // Navigate to the specified path
    };

    const handleBackClick = () => {
      navigate('/'); // Navigate to the home page
    };
  
    return (
      <div className="year-page">
        <h1>2024 Photos</h1>
        <button 
        className="back-button" 
        onClick={handleBackClick}
      >
        ← Back 
      </button>
        <div className="location-grid">
          {/* Uganda Location */}
          <div
            className="location-container"
            onClick={() => handleContainerClick('/uganda')} // Redirect to /uganda
            style={{ cursor: 'pointer' }} // Add pointer cursor to indicate clickability
          >
            <div
              className="image-container"
              style={{ backgroundImage: `url(${UgandaImage})` }}
            ></div>
            <p className="location-name">Uganda</p>
          </div>
  
          {/* Kyrgyzstan Location */}
          <div
            className="location-container"
            onClick={() => handleContainerClick('/kyrgyzstan')} // Redirect to /kyrgyzstan
            style={{ cursor: 'pointer' }} // Add pointer cursor to indicate clickability
          >
            <div
              className="image-container"
              style={{ backgroundImage: `url(${KyrgyzstanImage})` }}
            ></div>
            <p className="location-name">Kyrgyzstan</p>
          </div>
        </div>
      </div>
    );
  }
  
  export default Year2024;